import _curry1 from './private/curry1.js';
const toLower = _curry1( (str) => {
  	return str.toLowerCase();
});
export default toLower;


// WEBPACK FOOTER //
// ./src/common/bare-metal/toLower.js